import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {CashRegisterList} from './components/CashRegisterList';

export function CashRegisters() {
  const title = i18n.t('page.accounting.labels.cashRegisters');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate header={{title}} data-testid="cashregister-settings-modal">
        <CashRegisterList />
      </SettingsTemplate>
    </>
  );
}
